<form [formGroup]="meetingsform">
  <div class="d-flex justify-content-start gap-1 flex-wrap">
    <div style="max-width:140px;">
      <div class="form-group">
        <label for="fromDate">
          Från datum
        </label>
        <input type="text" class="form-control form-control-sm dateinput"
        mask="0000-00-00" formControlName="fromDate" format="YYYY-mm-dd"
          placeholder="YYYY-MM-DD" (change)="updateMeetingsview()" style="width:125px;">
      </div>
    </div>
    <div style="max-width:140px;">
      <div class="form-group">
        <label for="toDate">
          Till datum
        </label>
        <input type="text" class="form-control form-control-sm dateinput"
        mask="0000-00-00" formControlName="toDate" format="YYYY-mm-dd"
          placeholder="YYYY-MM-DD" (change)="updateMeetingsview()" style="width:125px;">
      </div>
    </div>
    <div>
      <div class="form-group">
        <label>&nbsp;</label>
        <div>
          <button class="btn border ms-2 ms-md-1" style="width: 120px;" (click)="viewPresence()">Visa möten</button>
          <button class="btn border ms-2" style="width: 70px;" (click)="meetings=[]">Rensa</button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-start custom-checkbox">
    <input type="checkbox" class="custom-control-input ms-3" id="cb" formControlName="OnlyIncludeOwnLodgeMeetings"
      (change)="updateMeetingsview()">
    <label class="custom-control-label ms-2" for="cb">Endast aktuell institution (inte aktiverad)</label>
  </div>
  <div class="row">
    <div class="col-md-4" *ngIf="meetings.length > 0" style="min-width:200px;margin-top:10px;">Antal möten:
      {{meetings.length}}</div>
  </div>
  <div class="resultdiv">
    <table matSort (matSortChange)="sortData($event)" class="table table-bordered" matSortDisableClear=true
      style="min-width: 550px;">
      <thead role="rowgroup">
        <tr>
          <th mat-sort-header="meeting">Möte</th>
          <th mat-sort-header="meetingDate">Datum</th>
          <th mat-sort-header="inst">Inst</th>
          <th>Typ</th>
          <th></th>
        </tr>
      </thead>
      <tr *ngFor="let m of meetings;">
        <td>
          <a *ngIf="m.currentUserCanEdit && !mobiledevice" [routerLink]="['/meetings/meetings/meetingdetails']"
            [queryParams]="{memberid: memberid, id: m.id, institutionid: m.institutionId}">
            {{m.issue}}
          </a>
          <span *ngIf="!m.currentUserCanEdit || mobiledevice">{{m.issue}}</span>
        </td>
        <td>{{m.meetingDate | date: 'yyyy-MM-dd'}}</td>
        <td>
          <a [routerLink]="['/institutions/id/', m.institutionId]"
            title="{{m.institutionName}}">{{m.institutionShortName}}</a>
        </td>
        <td>{{(m.meetingTypeName).substring(0,1)}}</td>
        <td style="text-align:center;">
          <a title="Ändra" *ngIf="m.currentUserCanEdit && !mobiledevice"
            [routerLink]="['/meetings/meetings/meetingdetails']" [queryParams]="{edit: true, id: m.id}">
            <span style="font-size:11px;color:rgb(20, 144, 185);" title="Ändra">Ändra</span>
          </a>
        </td>
      </tr>
    </table>
  </div>
</form>
<router-outlet></router-outlet>